export const parseAchievement = (rawMessage: TRawAchievement, isFirstLoad: boolean = false): TParsedMessage => {
  const { messageId, messageType, address, message, timestamp } = rawMessage
  let parsedMessage
  try {
    parsedMessage = JSON.parse(message)
  } catch (err) {
    parsedMessage = message
  }

  return {
    isFirstLoad,
    messageId,
    messageType,
    address,
    message: parsedMessage,
    timestamp,
  }
}
